module.exports = __webpack_public_path__ + "static/media/AE.87a05336.svg";